'use client';

/**
 * Marketing exterior — slow drifting planes and boats.
 */
export function MarketingAtmosphere() {
  return (
    <div className="piai-mkt-world" aria-hidden>
      <div className="piai-mkt-field" />
      <div className="piai-mkt-wash piai-mkt-wash-a" />
      <div className="piai-mkt-wash piai-mkt-wash-b" />
      <div className="piai-mkt-wash piai-mkt-wash-c" />
      <div className="piai-mkt-grain" />

      <div className="piai-mkt-drift">
        <PaperPlane className="piai-mkt-craft piai-mkt-plane-1" />
        <PaperPlane className="piai-mkt-craft piai-mkt-plane-2" />
        <PaperPlane className="piai-mkt-craft piai-mkt-plane-3" />
        <PaperBoat className="piai-mkt-craft piai-mkt-boat-1" />
        <PaperBoat className="piai-mkt-craft piai-mkt-boat-2" />
      </div>
    </div>
  );
}

function PaperPlane({ className }: { className: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      width="64"
      height="64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 30 L58 10 L34 54 L28 36 Z" fill="currentColor" fillOpacity="0.92" />
      <path d="M28 36 L58 10 L22 28 Z" fill="currentColor" fillOpacity="0.55" />
      <path d="M28 36 L34 54 L22 28" fill="currentColor" fillOpacity="0.35" />
      <path d="M6 30 L28 36 L22 28 Z" fill="#fffaf3" fillOpacity="0.35" />
    </svg>
  );
}

function PaperBoat({ className }: { className: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 72 48"
      width="72"
      height="48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 28 L36 8 L64 28 L54 40 L18 40 Z" fill="currentColor" fillOpacity="0.9" />
      <path d="M36 8 L36 40 L18 40 Z" fill="currentColor" fillOpacity="0.55" />
      <path d="M36 8 L36 40 L54 40 Z" fill="currentColor" fillOpacity="0.4" />
      <path
        d="M12 30 L36 16 L60 30"
        stroke="#fffaf3"
        strokeOpacity="0.45"
        strokeWidth="1.2"
        fill="none"
      />
      <ellipse cx="36" cy="42" rx="22" ry="3" fill="#2c2a26" fillOpacity="0.08" />
    </svg>
  );
}
